import React from 'react';
import { motion } from 'framer-motion';
import { Star, ShieldCheck, ArrowRight, Clock, Lock } from 'lucide-react';
import { CART_LINK, trackAddToCart } from '../lib/constants';
export function Hero() {
  return <section className="w-full px-5 md:px-8 py-20 md:py-32 overflow-hidden" data-id="element-91">
      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-16 items-center" data-id="element-92">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        ease: 'easeOut'
      }} className="flex flex-col gap-6" data-id="element-93">
          <span className="text-[11px] md:text-xs font-semibold tracking-[0.25em] uppercase text-primary" data-id="element-94">
            MOVÉ SUAVE™ <span className="mx-1" data-id="element-95">·</span> Sistema de Movimiento
            Suave
          </span>

          <h1 className="text-[2.75rem] sm:text-5xl md:text-6xl lg:text-7xl font-serif text-ink leading-[1.05] md:leading-[0.98] tracking-tight mt-2" data-id="element-96">
            Volvé a sentirte{' '}
            <em className="italic font-light text-primary" data-id="element-97">liviana</em>,
            flexible y conectada con tu cuerpo —{' '}
            <em className="italic font-light text-primary" data-id="element-98">sin culpa</em>, sin
            exigirte de más.
          </h1>

          <p className="text-[17px] md:text-xl text-ink/70 leading-[1.6] mt-2" data-id="element-99">
            El sistema premium de movimiento suave que podés sostener incluso en
            tus días más difíciles. Diseñado para cuerpos reales, días reales,
            energías reales.
          </p>

          <div className="flex flex-col md:flex-row md:items-center gap-2 md:gap-3 mt-2" data-id="element-100">
            <div className="flex items-center gap-1 text-gold" data-id="element-101">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 md:w-5 md:h-5 fill-current" data-id="element-102" />)}
            </div>
            <p className="text-sm text-ink/70 flex flex-wrap items-center gap-2" data-id="element-103">
              <span className="font-medium" data-id="element-104">
                +12.000 personas ya volvieron a moverse suave
              </span>
              <span className="hidden md:inline text-ink/30" data-id="element-105">·</span>
              <span className="flex items-center gap-1 text-primary" data-id="element-106">
                <ShieldCheck className="w-4 h-4" data-id="element-107" /> Compra Verificada
              </span>
            </p>
          </div>

          <div className="flex flex-col gap-6 mt-6" data-id="element-108">
            <a href={CART_LINK} onClick={() => trackAddToCart()} className="w-full md:w-auto inline-flex items-center justify-center gap-2 bg-ink text-base px-8 py-5 md:py-6 rounded-sm text-lg font-semibold tracking-wide hover:bg-ink/90 transition-all duration-300 hover:-translate-y-0.5 shadow-md hover:shadow-lg" data-id="element-109">
              Quiero sentirme mejor ahora <ArrowRight className="w-5 h-5" data-id="element-110" />
            </a>
            <p className="text-xs text-ink/60 text-center md:text-left flex flex-wrap items-center justify-center md:justify-start gap-2" data-id="element-111">
              <span className="flex items-center gap-1" data-id="element-112">
                <Clock className="hidden md:block w-3.5 h-3.5" data-id="element-113" /> Acceso
                inmediato
              </span>
              <span data-id="element-114">·</span>
              <span className="flex items-center gap-1" data-id="element-115">
                <Lock className="hidden md:block w-3.5 h-3.5" data-id="element-116" /> Pago único
              </span>
              <span data-id="element-117">·</span>
              <span className="flex items-center gap-1" data-id="element-118">
                <ShieldCheck className="hidden md:block w-3.5 h-3.5" data-id="element-119" /> Garantía
                60 días
              </span>
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.8,
        ease: 'easeOut',
        delay: 0.2
      }} className="relative w-full bg-primary/5 rounded-3xl p-2 md:p-3" data-id="element-120">
          <div className="relative w-full rounded-2xl overflow-hidden bg-secondary/40" data-id="element-121">
            <img src="https://cdn.shopify.com/s/files/1/0996/2510/7821/files/ChatGPT_Image_19_may_2026_12_23_25_p.m..png?v=1779204217" alt="MOVÉ SUAVE — movimiento suave premium" className="w-full h-auto object-contain" data-id="element-122" />
          </div>
        </motion.div>
      </div>
    </section>;
}